import Modal from "../../../components/common/Modal";

const AdditionlaInfoPopup = ({
  setOpenAdditionalInfoPopup,
  additionalInfo = [],
}: {
  setOpenAdditionalInfoPopup: (value: boolean) => void;
  additionalInfo?: string[];
}) => {
  return (
    <div>
      <div>
        <Modal
          clickOutsideToClose
          header="Additional Information"
          handleCancel={() => setOpenAdditionalInfoPopup(false)}
        >
          <div className="py-4">
            {additionalInfo && additionalInfo.length > 0 ? (
              <div className="space-y-1">
                {additionalInfo.map((info: string, index: number) => (
                  <div key={index} className="bg-gray-50 p-3 rounded-md">
                    <p className="text-sm text-gray-800">{info}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-500 text-center">
                No additional information available.
              </p>
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default AdditionlaInfoPopup;
